import { AppText, Button, Card, IconButton, styled, Subheader, useTheme } from '@streem/ui-react';
import { FC, PropsWithChildren } from 'react';

interface InfoCardProps {
    handleCancel: () => void;
    handleOkay: () => void;
    Container?: FC<PropsWithChildren>;
}

export const VideoPreviewInfoCard: FC<PropsWithChildren<InfoCardProps>> = ({
    handleCancel,
    handleOkay,
    Container,
}) => {
    const ContainerToUse: FC<React.PropsWithChildren> = Container || InfoCardContainer;
    const theme = useTheme();
    return (
        <ContainerToUse>
            <Card
                decoratorPosition="side"
                style={{
                    position: 'relative',
                    height: '100%',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <div style={{ position: 'absolute', top: '30px', right: '30px' }}>
                    <IconButton
                        iconName={'CloseIcon'}
                        size="medium"
                        label="info-card-cancel-button"
                        onClick={handleCancel}
                        background="azure"
                        fill="white"
                    />
                </div>
                <Subheader>Video Preview</Subheader>
                <div
                    style={{
                        flexGrow: 1,
                        marginTop: theme.space[5],
                    }}
                >
                    <AppText>
                        This is a preview of your video and does not include any audio. We are still
                        processing your final video and it will be available ASAP.
                    </AppText>
                </div>
                <Button
                    width="150px"
                    onClick={handleOkay}
                    data-testid="info-card-okay-button"
                    style={{
                        alignSelf: 'flex-end',
                    }}
                >
                    Okay
                </Button>
            </Card>
        </ContainerToUse>
    );
};

const InfoCardContainer = styled('div')`
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    z-index: 1;
    width: 80%;
    height: 80%;
`;
